import { createApp } from "vue"
import SignupSingleNewsletter from "./SignupSingleNewsletter"
import { VueReCaptcha } from 'vue-recaptcha-v3'

const el = ".nyk-component--signup-single-newsletter"

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((SignupSingleNewsletterDOM) => {
            const recaptchaSiteKey = SignupSingleNewsletterDOM.dataset.recaptchaSiteKey;
            const antiForgeryToken = SignupSingleNewsletterDOM.dataset.antiForgeryToken
            const labels = JSON.parse(SignupSingleNewsletterDOM.dataset.labels)
            const formId = SignupSingleNewsletterDOM.dataset.formId
            const formTypeName = SignupSingleNewsletterDOM.dataset.formTypeName
            const apiUrl = SignupSingleNewsletterDOM.dataset.apiUrl
            const enableUserTrack = SignupSingleNewsletterDOM.dataset.enableUserTrack ? JSON.parse(SignupSingleNewsletterDOM.dataset.enableUserTrack) : false
            const newsletters = SignupSingleNewsletterDOM.dataset.newsletters
                ? JSON.parse(SignupSingleNewsletterDOM.dataset.newsletters)
                : []

            const component = createApp(SignupSingleNewsletter, {
                antiForgeryToken,
                labels,
                formId,
                formTypeName,
                apiUrl,
                enableUserTrack,
                newsletters,
            })
                .use(Store)
                .use(VueReCaptcha, { siteKey: recaptchaSiteKey })
            component.mount(SignupSingleNewsletterDOM)
        })
    }
}
